<template>
  <section
    class="flex flex-col items-center pt-0 md:pt-16 pb-12 lg:pt-[102px] lg:pb-16"
  >
    <div class="mx-auto min-w-[320px] max-w-[1200px] px-4">
      <h1 class="landing_h1 mb-6 text-center md:text-left">
        <Translate translate-key="page_data.selling-tradelines.h1" />
      </h1>
      <div
        class="prose prose-gray max-w-none mb-8 text-left prose-p:mb-3 prose-ul:my-3 prose-li:my-0.5 prose-a:text-success prose-a:underline hover:prose-a:no-underline"
      >
        <p class="text-gray-700">
          <Translate translate-key="selling_tradelines_page.after_title" />
        </p>
        <p>
          <Translate translate-key="selling_tradelines_page.view_our" />
          &nbsp;
          <NuxtLink
            :to="localePath('/commissions-for-selling-tradelines')"
            class="text-success underline hover:no-underline"
          >
            <Translate translate-key="selling_tradelines_page.link" />
          </NuxtLink>
          &nbsp;
          <Translate translate-key="selling_tradelines_page.after_link" />
        </p>
        <p class="font-bold">
          <Translate
            translate-key="selling_tradelines_page.why_best_option.title"
          />
        </p>
        <ul
          class="ml-0 pl-1 md:ml-4 list-inside list-disc space-y-1 text-gray-700"
        >
          <li v-for="key in whyBestOptionKeys" :key="key">
            <Translate
              :translate-key="`selling_tradelines_page.why_best_option.${key}`"
            />
          </li>
        </ul>
        <div class="flex justify-center pt-6">
          <Button
            v-if="!currentUserStore.isAuthenticated"
            as="a"
            :href="linkHref('/signup?type=cardholder')"
            variant="landing1"
            size="xl"
          >
            <Translate
              translate-key="selling_tradelines_page.start_selling_now"
            />
          </Button>
          <Button
            v-else-if="!currentUserStore.isCardholder"
            as="a"
            :href="linkHref('/#contact')"
            variant="landing1"
            size="xl"
          >
            <Translate
              translate-key="selling_tradelines_page.start_selling_now"
            />
          </Button>
          <a
            v-else
            :href="linkHref('/cardholder')"
            class="inline-block rounded-lg bg-landing-primary px-8 py-4 font-semibold text-white hover:bg-landing-primary-hover"
          >
            <Translate translate-key="services_common_home.start_selling" />
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import Translate from "~/shared/components/i18n/Translate/Translate.vue";
import { Button } from "~/shared/components/ui/button";
import { useI18n } from "vue-i18n";
import { useCurrentUserStore } from "~/stores/userStore";

const { linkHref } = useNativeRouteLink();
const localePath = useLocalePath();
const { t } = useI18n();
const currentUserStore = useCurrentUserStore();

const whyBestOptionKeys = [
  "cutting_edge_platform",
  "automation",
  "inventory",
  "experience",
  "resources",
  "support",
  "referral",
  "security",
];
</script>

<style scoped></style>
